import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { IKerwordsTypeDetails, IKerwordsTypeSeachFields, keyWordsService, IKerwordsDetails, IKerwordsSeachFields, IKerwordsTypeInsert, IKerwordsInsert } from "./keyWordsService";
import { ISearchPage, ISelectOptions } from "@/types/AppTypes";
import { transPgToPagination } from "@/model/globalModel";
import { message } from "antd";

interface IKeyWordsDrawerType {
    visible: boolean,
    mode: "add" | "edit"
}

export const useKeyWordsModel = createModel(function () {
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    /*关键词分类*/
    const [dataSourceType, setDataSourceType] = useState<IKerwordsTypeDetails[]>([]);
    const [searchParamType, setSearchParamType] = useState<IKerwordsTypeSeachFields>({})
    const [pgCfgType, setPgCfgType] = useState<TablePaginationConfig>(initPgCfg);
    const [selectedRowKeysType, setSelectedRowKeysType] = useState<IKerwordsTypeDetails[]>([]);
    const [keyWordsTypeDrawer, setKeyWordsTypeDrawer] = useState<IKeyWordsDrawerType>({ visible: false, mode: "add" });
    const [keyWordsTypeOptions, setKeyWordsTypeOptions] = useState<ISelectOptions[]>([]);

    //列表查询
    const loadDataType = async (page: ISearchPage = initPgCfg, searchValue: any = searchParamType) => {
        const searchParams = {
            ...searchValue,
            pageSize: -1,
            pageNum: 1,
            // pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            // pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await keyWordsService.pageType(searchParams);
        const { records, ...pg } = retData;
        // setPgCfgType(transPgToPagination(pg));
        setDataSourceType(records);
        setKeyWordsTypeOptions(() => records.map(item => ({ label: item.name, value: item.id })));
        return records;
    }

    const insertKeyWordsType = async (obj: IKerwordsTypeInsert) => {
        let { retData } = await keyWordsService.insertType(obj);
        retData && loadDataType(initPgCfg);
        setKeyWordsTypeDrawer({ visible: false, mode: "add" });
        message.success("分类新增成功");
    }

    const updataKeyWordsType = async (obj: IKerwordsTypeDetails, txt?: string) => {
        let { retData } = await keyWordsService.updataType(obj);
        retData && loadDataType(initPgCfg);
        setKeyWordsTypeDrawer({ visible: false, mode: "add" });
        message.success(`${txt ?? '分类编辑成功'}`);
    }

    const removeKeyWordsType = async (id: string) => {
        let { retData } = await keyWordsService.removeType(id);
        retData && loadDataType(initPgCfg);
        message.success("删除成功")
    }

    /*关键词 */
    const [dataSource, setDataSource] = useState<IKerwordsDetails[]>([]);
    const [searchParam, setSearchParam] = useState<IKerwordsSeachFields>({});
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [selectedRowKeys, setSelectedRowKeys] = useState<IKerwordsDetails[]>();
    const [keyWordsDrawer, setKeyWordsDrawer] = useState<IKeyWordsDrawerType>({ visible: false, mode: "add" });
    const [loading, setLoading] = useState<boolean>(false);
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IKerwordsSeachFields = searchParam) => {
        setLoading(true)
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        try {
            let { retData } = await keyWordsService.page(searchParams);
            const { records, ...pg } = retData;
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
            setLoading(false);
            return records;
        } catch (err) { setLoading(false) }
    }

    const insertKeyWords = async (obj: IKerwordsInsert) => {
        let { retData } = await keyWordsService.insert(obj);
        retData && loadData(initPgCfg);
        setKeyWordsDrawer({ visible: false, mode: "add" });
        message.success("关键词新增成功");
    }

    const updataKeyWords = async (obj: IKerwordsDetails, txt?: string) => {
        let { retData } = await keyWordsService.updata(obj);
        retData && loadData(initPgCfg);
        setKeyWordsDrawer({ visible: false, mode: "add" });
        message.success(`${txt ?? '关键词编辑成功'}`);
    }

    const removeKeyWords = async (id: string) => {
        let { retData } = await keyWordsService.remove(id);
        retData && loadData(initPgCfg);
        message.success("删除成功")
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        searchParamType,
        dataSourceType,
        selectedRowKeysType,
        pgCfgType,
        keyWordsTypeOptions,
        loading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        setSearchParam,
        loadData,
        setDataSourceType,
        setSelectedRowKeysType,
        setSearchParamType,
        loadDataType,
        keyWordsDrawer, setKeyWordsDrawer,
        keyWordsTypeDrawer, setKeyWordsTypeDrawer,
        insertKeyWordsType,
        removeKeyWordsType,
        updataKeyWordsType,
        insertKeyWords,
        removeKeyWords,
        updataKeyWords
    }
});